import api from './api';

export const relatorioService = {
  async listarVendas({ startDate, endDate, sortBy = 'TB02021_DATA', sortOrder = 'DESC', page = 1, pageSize = 50, q }) {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (sortBy) params.sortBy = sortBy;
    if (sortOrder) params.sortOrder = sortOrder;
    params.page = page;
    params.pageSize = pageSize;
    if (q !== undefined) params.q = q;

    const { data } = await api.get('/relatorio/vendas', { params });
    return data;
  },

  async listarVendasConcluidas({ startDate, endDate, vendaStartDate, vendaEndDate, baixaStartDate, baixaEndDate, sortBy = 'DATA_BAIXA', sortOrder = 'DESC', page = 1, pageSize = 50, q }) {
    const params = {};
    // Suporte ao alias antigo (startDate/endDate -> baixa*)
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    // Novos filtros específicos
    if (vendaStartDate) params.vendaStartDate = vendaStartDate;
    if (vendaEndDate) params.vendaEndDate = vendaEndDate;
    if (baixaStartDate) params.baixaStartDate = baixaStartDate;
    if (baixaEndDate) params.baixaEndDate = baixaEndDate;
    if (sortBy) params.sortBy = sortBy;
    if (sortOrder) params.sortOrder = sortOrder;
    params.page = page;
    params.pageSize = pageSize;
    if (q !== undefined) params.q = q;

    const { data } = await api.get('/relatorio/vendas-concluidas', { params });
    return data;
  }
};